<template>
  <div class="title-description-container">
    <div v-if="!hideStatus && mode !== 'segmentation' && !(mode === 'PONTOS' && status === '')" class="title-description-status">
      <mf-icon fill class="status-icon" small :color="getColor(status)" :icon="status === 'processing' ? 'processing' : 'stop_circle'" />
      <span>{{ formatStatus(status) }}</span>
    </div>
    <div v-if="showStatusProcessingMessage" class="status-processing-message">
      <p>
        Esta campanha não pode ser editada pois foi ativada ou editada por um usuário e está em status de processamento. Tente novamente em alguns momentos.
      </p>
    </div>
    <mf-card-container v-if="newStyle" title="Título e descrição">
      <div class="card-grid mt-2">
        <div>
          <label for="campaign-title">Título da campanha</label>
          <v-text-field
            id="campaign-title"
            ref="title"
            v-model="titleLocal"
            outlined
            :error-messages="getTitleErrorMessages"
            :hide-details="hideDetails"
            :disabled="disableTitle"
            :counter="counter.title"
            maxlength="70"
            data-cy="title"
            placeholder="Título da campanha"
          />
        </div>
        <div>
          <label for="campaign-description">Descrição</label>
          <v-text-field
            id="campaign-description"
            v-model="descriptionLocal"
            outlined
            :error-messages="getDescriptionErrorMessages"
            :hide-details="hideDetails"
            :disabled="disableDescription"
            :counter="counter.description"
            maxlength="150"
            data-cy="description"
            placeholder="Descrição"
          />
        </div>
      </div>
      <slot />
    </mf-card-container>

    <mf-card-container v-else :title="useCardTitle ? 'Configurações da campanha' : ''">
      <div class="title-description-card">
        <div class="text-field-title">
          <tooltip :disabled="isIndustryCampaign ? !disableTitle : true" :message="tooltipMessage">
            <label class="text-field-label">Título</label>
            <v-text-field
              ref="title"
              v-model="titleLocal"
              dense
              outlined
              :error-messages="getTitleErrorMessages"
              :hide-details="hideDetails"
              :disabled="disableTitle"
              :counter="counter.title"
              data-cy="title"
            />
          </tooltip>
        </div>
        <div class="text-field-description">
          <tooltip :disabled="isIndustryCampaign ? !disableDescription : true" :message="tooltipMessage">
            <label class="text-field-label">Descrição</label>
            <v-text-field
              v-model="descriptionLocal"
              dense
              outlined
              :error-messages="getDescriptionErrorMessages"
              :hide-details="hideDetails"
              :disabled="disableDescription"
              :counter="counter.description"
              data-cy="description"
            />
          </tooltip>
        </div>
      </div>
      <slot name="additional-content"></slot>
    </mf-card-container>
  </div>
</template>

<script>
import Tooltip from '../../../gestao-ofertas-v2/views/components/Tooltip.vue'

export default {
  components: {
    Tooltip,
  },

  props: {
    title: String,
    titleError: Boolean,
    description: String,
    descriptionError: Boolean,
    status: String,
    hideDetails: Boolean,
    titleErrorMessage: String,
    descriptionErrorMessage: String,
    disableTitle: Boolean,
    disableDescription: Boolean,
    showStatusProcessingMessage: {
      type: Boolean,
      default: false,
    },
    mode: String,
    counter: {
      type: Object,
      default() {
        return {
          title: '',
          description: '',
        }
      },
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
    isIndustryCampaign: {
      type: Boolean,
      default: false,
    },
    noMaxHeight: {
      type: Boolean,
      default: false,
    },
    newStyle: {
      type: Boolean,
      default: false,
    },
    hideStatus: {
      type: Boolean,
      default: false,
    },
    useCardTitle: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    titleLocal: {
      get() {
        return this.title
      },

      set(value) {
        this.$emit('update:title', value)
      },
    },
    getTitleErrorMessages() {
      if (this.titleError) return this.titleErrorMessage
      else return ''
    },
    getDescriptionErrorMessages() {
      if (this.descriptionError) return this.descriptionErrorMessage
      else return ''
    },
    descriptionLocal: {
      get() {
        return this.description
      },

      set(value) {
        this.$emit('update:description', value)
      },
    },
  },
  watch: {
    getTitleErrorMessages(newVal) {
      if (newVal) this.$refs.title.$el.getElementsByTagName('input')[0].focus()
    },
  },
  methods: {
    getColor(status) {
      switch (status?.toUpperCase()) {
        case 'DRAFT':
        case 'INACTIVE':
          return '#bfbfbf'
        case 'SCHEDULED':
        case 'ON_APPROVAL':
          return '#ffe200'
        case 'FINISHED':
          return '#2c67e6'
        case 'ACTIVE':
          return '#03e36a'
        case 'INDUSTRY_PROPOSAL':
          return '#002040'
        case 'EXPIRED':
          return '#F15435'
        default:
          return '#bfbfbf'
      }
    },
    formatStatus(status) {
      switch (status?.toUpperCase()) {
        case 'DRAFT':
          return 'Rascunho'
        case 'SCHEDULED':
          return this.mode === 'PONTOS' ? 'Agendado' : 'Agendada'
        case 'FINISHED':
          return this.mode === 'PONTOS' ? 'Concluído' : 'Concluída'
        case 'ACTIVE':
          return ['PONTOS', 'WHATSAPP_FLOW'].includes(this.mode) ? 'Ativo' : 'Ativa'
        case 'INDUSTRY_PROPOSAL':
          return 'Proposta Indústria'
        case 'EXPIRED':
          return 'Expirada'
        case 'INACTIVE':
          return 'Inativa'
        case 'PROCESSING':
          return 'Processando'
        case 'ON_APPROVAL':
          return 'Em aprovação'
        default:
          return 'Rascunho'
      }
    },
  },
}
</script>

<style lang="scss">
.title-description-container {
  height: 100%;
  .title-description-status {
    display: flex;
    align-items: center;
    margin: 0 0 10px 0;
    .status-icon {
      font-size: 12px !important;
    }
    span {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      letter-spacing: 0.2px;
      color: $cinza-d20;
      text-transform: uppercase;
      padding-left: 5px;
    }
  }

  .status-processing-message {
    background: $vermelho-d20;
    padding: 12px 20px;
    box-shadow: $shadow-card;
    border-radius: 8px;
    margin: 12px 0;
    p {
      margin: 0;
      color: $branco;
      font-size: 16px;
    }
  }

  .title-description-card {
    display: flex;
    flex-direction: row;
    gap: 20px;

    .v-input__slot {
      margin: 8px 0 4px 0 !important;
    }

    .v-text-field__details {
      padding-left: 0 !important;
    }
    .text-field-title {
      width: 30%;
    }
    .text-field-description {
      width: 80%;
    }
    .text-field-description,
    .text-field-title {
      .text-field-label {
        color: $cinza-d10;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}

.card-grid {
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: center;
  gap: 20px;

  label {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: $cinza-d10;
    margin-bottom: 8px;
  }
}
</style>
